import { PricesContainer } from 'shared/containers/Prices';
import { PromoFeatures } from 'shared/components/PromoFeatures';
import { NewPromoContainer } from '../NewPromo';

export const PriceContentContainer: React.FC = () => {
  return (
    <>
      <NewPromoContainer
        title="Стоимость нового продвижения на Циан"
        subtitle="Размещение объявлений - без изменений"
      />
      <PromoFeatures />
      <PricesContainer />
    </>
  );
};
